<template>
  <div v-if="open" class="rd-pop rd-pop--help" role="dialog" :aria-label="$t('report_desktop.shortcuts')">
    <div class="rd-pop__head">
      <span>{{ $t("report_desktop.shortcuts") }}</span>
      <button type="button" class="ui-icon-btn ui-icon-btn--sm" :aria-label="$t('close')" @click="$emit('close')">
        <v-icon size="16">mdi-close</v-icon>
      </button>
    </div>
    <div v-for="item in shortcuts" :key="item.keys" class="rd-help-row">
      <span>{{ item.label }}</span>
      <kbd>{{ item.keys }}</kbd>
    </div>
  </div>
</template>

<script>
/** Spisak prečica tastature izveštaja. */
export default {
  name: "ReportHelpPopover",
  props: {
    open: { type: Boolean, default: false },
    /** [{ keys, label }] */
    shortcuts: { type: Array, default: () => [] },
  },
};
</script>
